module.exports = __webpack_public_path__ + "img/ems.11a833fe.png";